(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["based-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.based-countdown').forEach(function (root) {
      var target = root.getAttribute('data-target');
      if (!target) return;
      var endAt = Date.parse(target);
      if (isNaN(endAt)) return;

      var dEl = root.querySelector('[data-countdown-days]');
      var hEl = root.querySelector('[data-countdown-hours]');
      var mEl = root.querySelector('[data-countdown-minutes]');
      var sEl = root.querySelector('[data-countdown-seconds]');
      var endMsg = root.querySelector('[data-countdown-end-message]');
      var cells = root.querySelector('.based-countdown__cells');

      function tick() {
        var now = Date.now();
        var diff = endAt - now;
        if (diff <= 0) {
          if (cells) cells.hidden = true;
          if (endMsg) endMsg.hidden = false;
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = days;
        if (hEl) hEl.textContent = ('0' + hours).slice(-2);
        if (mEl) mEl.textContent = ('0' + minutes).slice(-2);
        if (sEl) sEl.textContent = ('0' + seconds).slice(-2);
      }
      tick();
      setInterval(tick, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["based-pdp-buy-box"] && !Shopify.designMode) return;
  try {
    (function () {
    // Countdown ticker
    document.querySelectorAll('[data-based-countdown]').forEach(function (cd) {
      var endIso = cd.dataset.end;
      if (!endIso) return;
      var end = new Date(endIso).getTime();
      var clock = cd.querySelector('[data-based-countdown-clock]');
      function tick(){
        var d = end - Date.now();
        if (d <= 0) { cd.style.display='none'; return; }
        var s = Math.floor(d/1000);
        var dd = Math.floor(s/86400); s -= dd*86400;
        var hh = Math.floor(s/3600);  s -= hh*3600;
        var mm = Math.floor(s/60);    var ss = s - mm*60;
        var pad = function(n){return n<10?'0'+n:''+n;};
        clock.textContent = pad(dd)+':'+pad(hh)+':'+pad(mm)+':'+pad(ss);
      }
      tick(); setInterval(tick, 1000);
    });
    document.querySelectorAll('.based-buybox').forEach(function (root) {
      var hiddenId = root.querySelector('[data-based-selected-variant-id]');
      var atc = root.querySelector('[data-based-atc]');
      var qtyInput = root.querySelector('[data-based-qty-input]');
      var decBtn = root.querySelector('[data-based-qty-decrement]');
      var incBtn = root.querySelector('[data-based-qty-increment]');
      function ensureATCParts(button) {
        var labelEl = button.querySelector('.based-buybox__atc-label');
        var priceEl = button.querySelector('.based-buybox__atc-price');
        var compareEl = button.querySelector('[data-based-atc-compare]');
        if (labelEl && priceEl && compareEl) return { label: labelEl, price: priceEl, compare: compareEl };
        button.textContent = '';
        labelEl = document.createElement('span');
        labelEl.className = 'based-buybox__atc-label';
        priceEl = document.createElement('span');
        priceEl.className = 'based-buybox__atc-price';
        priceEl.setAttribute('data-based-atc-price', '');
        compareEl = document.createElement('s');
        compareEl.className = 'based-buybox__atc-compare';
        compareEl.setAttribute('data-based-atc-compare', '');
        button.appendChild(labelEl);
        button.appendChild(priceEl);
        button.appendChild(compareEl);
        return { label: labelEl, price: priceEl, compare: compareEl };
      }
      function renderATCFromCard(card) {
        if (!atc || !card) return;
        var available = card.dataset.variantAvailable === 'true';
        var state = card.dataset.variantPurchaseState || (available ? 'add_to_cart' : 'out_of_stock');
        var parts = ensureATCParts(atc);
        atc.dataset.purchaseState = state;
        atc.classList.toggle('based-buybox__atc--notify', state === 'notify_me');
        atc.classList.toggle('based-klaviyo-notify-trigger', state === 'notify_me');
        atc.setAttribute('type', state === 'notify_me' ? 'button' : 'submit');
        atc.disabled = state === 'out_of_stock';
        if (state === 'out_of_stock') {
          parts.label.textContent = atc.dataset.oosLabel || 'SOLD OUT';
          parts.price.textContent = '';
          parts.compare.textContent = '';
          return;
        }
        if (state === 'notify_me') {
          parts.label.textContent = atc.dataset.notifyLabel || 'NOTIFY ME';
          parts.price.textContent = '';
          parts.compare.textContent = '';
          return;
        }
        parts.label.textContent = atc.dataset.label || 'ADD TO CART';
        var p = parseInt(card.dataset.variantPrice, 10);
        if (!isNaN(p)) parts.price.textContent = '$' + (p/100).toFixed(2);
        var cmp = parseInt(card.dataset.variantCompareAt, 10);
        parts.compare.textContent = (!isNaN(cmp) && cmp > 0 && cmp > p)
          ? '$' + (cmp/100).toFixed(2)
          : '';
      }

      root.querySelectorAll('[data-based-variant-card]').forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.classList.contains('based-buybox__variant-card--selected')) return;
          root.querySelectorAll('[data-based-variant-card]').forEach(function (c) {
            c.classList.remove('based-buybox__variant-card--selected');
            var r = c.querySelector('input[type=radio]');
            if (r) r.checked = false;
          });
          card.classList.add('based-buybox__variant-card--selected');
          var radio = card.querySelector('input[type=radio]');
          if (radio) radio.checked = true;
          if (hiddenId) hiddenId.value = card.dataset.variantId;
          renderATCFromCard(card);
          root.dispatchEvent(new CustomEvent('based:variant-change', {
            bubbles: true,
            detail: { variantId: card.dataset.variantId, price: card.dataset.variantPrice }
          }));
        });
      });

      if (decBtn && qtyInput) decBtn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      if (incBtn && qtyInput) incBtn.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });

      if (atc) {
        atc.addEventListener('click', function (event) {
          if (atc.dataset.purchaseState !== 'notify_me') return;
          event.preventDefault();
          var formId = atc.dataset.klaviyoFormId;
          if (!formId) return;
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
        });
      }
    });

    if (window.location.search.indexOf('notify=1') !== -1) {
      window.setTimeout(function () {
        var trigger = document.querySelector('.based-klaviyo-notify-trigger');
        if (trigger) {
          var motionOkay = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          try { trigger.scrollIntoView({ behavior: motionOkay ? 'smooth' : 'auto', block: 'center' }); } catch (e) {}
          try { trigger.focus({ preventScroll: true }); } catch (e) {}
          try { trigger.click(); } catch (e) {}
        }
      }, 1200);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["based-product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.based-gallery').forEach(function (root) {
      var main = root.querySelector('[data-based-gallery-main]');
      var thumbs = root.querySelector('[data-based-gallery-thumbs]');
      if (!main) return;

      var slides = Array.from(main.querySelectorAll('[data-based-slide-id]'));
      var thumbBtns = thumbs ? Array.from(thumbs.querySelectorAll('[data-based-thumb-id]')) : [];
      var productJsonPromise = null;

      function activate(id) {
        slides.forEach(function (s) {
          s.classList.toggle('based-gallery__slide--active', s.dataset.basedSlideId === id);
        });
        thumbBtns.forEach(function (t) {
          t.classList.toggle('based-gallery__thumb--active', t.dataset.basedThumbId === id);
        });
      }

      function fileKey(url) {
        if (!url) return '';
        return String(url).split('?')[0].split('/').pop();
      }

      function productJson() {
        if (!productJsonPromise) {
          productJsonPromise = fetch(window.location.pathname.replace(/\/$/, '') + '.js', {
            headers: { Accept: 'application/json' }
          }).then(function (res) {
            if (!res.ok) throw new Error('product json failed');
            return res.json();
          }).catch(function () { return null; });
        }
        return productJsonPromise;
      }

      function activateVariantMedia(variantId) {
        if (!variantId) return;
        productJson().then(function (product) {
          if (!product || !product.variants) return;
          var variant = product.variants.find(function (v) { return String(v.id) === String(variantId); });
          var featured = variant && variant.featured_image && variant.featured_image.src;
          var key = fileKey(featured);
          if (!key) return;
          var match = slides.find(function (slide) {
            var img = slide.querySelector('img');
            return img && fileKey(img.currentSrc || img.src) === key;
          });
          if (match) activate(match.dataset.basedSlideId);
        });
      }

      function currentIndex() {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('based-gallery__slide--active')) return i;
        }
        return 0;
      }

      function step(delta) {
        if (slides.length < 2) return;
        var n = slides.length;
        var i = (currentIndex() + delta + n) % n;
        activate(slides[i].dataset.basedSlideId);
      }

      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { activate(btn.dataset.basedThumbId); });
      });

      var prev = root.querySelector('[data-based-gallery-prev]');
      var next = root.querySelector('[data-based-gallery-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      function syncSelectedVariantMedia() {
        var selectedInput = document.querySelector('[data-based-selected-variant-id]');
        if (selectedInput) activateVariantMedia(selectedInput.value);
      }
      syncSelectedVariantMedia();
      document.addEventListener('DOMContentLoaded', syncSelectedVariantMedia);
      setTimeout(syncSelectedVariantMedia, 250);
      setTimeout(syncSelectedVariantMedia, 1000);
      document.addEventListener('based:variant-change', function (event) {
        activateVariantMedia(event.detail && event.detail.variantId);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
